<template>
  <div class="item">
    <h3 class="item-title">{{decodeURIComponent(classItem.title)}}<span class="edit-icon"
                                                                             @click="openChangeTitle"></span></h3>
    <p class="item-time">发布时间:{{classItem.addtime.substring(0,16)}}</p>
    <!--<p class="item-name">学生姓名:{{decodeURIComponent(classItem.studentname)}}</p>-->
    <!--<template v-if="classItem.isanswer=='0'">-->
      <!--<p class="item-noanswer">未作答</p>-->
    <!--</template>-->
    <button v-if="classItem.progress>=1&&!isComplete" class="answer-btn" @click="QueryHomeWorkContent(classItem)">完结作业</button>
    <button class="edit-btn" @click="goEdit(classItem)">
      <template v-if="isComplete">查看</template>
      <template v-else>
        <template v-if="classItem.answernum ==0">修改</template>
        <template v-else>回复</template>
      </template>
    </button>
    <el-dialog :visible.sync="nameShow" title="修改作业标题">
      <el-input v-model="titlename" placeholder="请输入内容"></el-input>
      <section style="padding-top:40px;">
        <el-button @click="nameShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmChangeName">确 定</el-button>
      </section>
    </el-dialog>
    <el-dialog :visible.sync="rateShow" title="完结作业">
      <template v-for="item in contentsList">
        <div class="block">
          <span class="name" style="float:left;margin-right:20px">{{item.username}}</span>
          <el-rate  v-model="item.rate" @change="changeRate"></el-rate>
        </div>
      </template>
      <section style="padding-top:40px;">
        <el-button @click="rateShow = false">取 消</el-button>
        <el-button type="primary" @click="finishHomework">确 定</el-button>
      </section>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      id: {
        type: String
      },
      classinfo: {
        type: Object
      },
      isComplete:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        classItem: '',
        nameShow: false,
        titlename: '',
        contentsList:[],
        rateShow:false
      }
    },
    methods: {
      openChangeTitle() {
        this.nameShow = true;
        this.titlename = decodeURIComponent(this.classItem.title);
      },
      QueryHomeWorkContent(item) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryHomeWorkContent',
            id: this.id,
            classid: item.classid,
            homeworkid: item.id
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list[0];
            this.contentsList=list.content;
            this.contentsList.forEach((ele)=>{
              ele.rate=0;
            })
            this.rateShow=true;
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      changeRate(){
        this.$forceUpdate();
      },
      finishHomework(){
        this.contentsList.forEach((ele)=>{
          if(ele.rate==0){
            this.$message({
              message:'请给学生打分',
              type:'warning'
            })
            return;
          }
        })
        let upList=[];
        this.contentsList.forEach((ele)=>{
          let item={};
          item.uid=ele.userid;
          item.point=ele.rate*20;
          upList.push(item)
        })
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'UpdateHomeWorkPoint',
            id: this.id,
            classid: this.classItem.classid,
            homeworkid: this.classItem.id,
            pointlist: encodeURIComponent(JSON.stringify(upList)),
            islock:1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '完结作业成功',
              type: 'success'
            });
            this.rateShow = false;
            this.$emit('completeWork');
          }
        }).catch((err) => {

        })
      },
      goEdit(item) {
        if(this.isComplete){
          this.$router.push(
            {
              path: '/homework/complete',
              query: {
                title: decodeURIComponent(item.title),
                rid: item.rid,
                lessonid: item.lessonid,
                classid: item.classid,
                homeworkid: item.id,
              }
            }
          )
        }else{
          this.$router.push(
            {
              path: '/homework/init',
              query: {
                title: decodeURIComponent(item.title),
                rid: item.rid,
                lessonid: item.lessonid,
                classid: item.classid,
                homeworkid: item.id
              }
            }
          )
        }
      },
      confirmChangeName() {
        if (this.titlename == '') {
          this.$message({
            message: '请输入标题',
            type: 'warning'
          })
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'UpdateHomeWork',
            id: this.id,
            classid: this.classItem.classid,
            homeworkid: this.classItem.id,
            title: this.titlename,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '修改标题成功',
              type: 'success'
            });
            this.classItem.title = this.titlename;
            this.nameShow = false;
          }
        }).catch((err) => {

        })
      },
    },
    created() {

    },
    mounted() {

    },
    watch: {
      classinfo: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler(val, oldVal) {
          this.classItem = this.classinfo;
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .item {
    display: inline-block;
    padding-left: 30px;
    width: 578px;
    height: 200px;
    margin: 0 10px 10px 0;
    box-sizing: border-box
    background: #fff
    border-radius: 6px
    position: relative
    vertical-align: top
    &:nth-child(2n) {
      margin-right: 0px
    }
    .item-title {
      margin: 30px 0 15px;
      width: 500px;
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      vertical-align: middle
      .edit-icon {
        margin-left: 5px;
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle
        background: url('./edit.png') no-repeat center / 20px 20px;
        cursor: pointer
        &:hover {
          background-image: url('./edit-hover.png')
        }
      }
    }
    .item-time, .item-name {
      font-size: 16px;
      color: #999;
      height: 22px;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .item-name {
      margin-bottom: 29px;
    }
    .item-noanswer {
      font-size: 16px;
      color: #ff6700;
    }
    .answer-btn, .edit-btn {
      position: absolute;
      bottom: 20px;
      display: inline-block;
      font-size: 16px;
      color: #333;
      width: 100px;
      height: 32px;
      line-height: 30px;
      box-sizing: border-box
      border-radius: 4px;
      border: 1px solid #e9e9e9
      &:hover {
        color: #ff6700;
        border-color: #ff6700
      }
    }
    .answer-btn {
      right: 140px;
    }
    .edit-btn {
      right: 30px;
      .hint-dot {
        position: absolute;
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #ff6700;
        top: 4px;
        right: 22px
        border-radius: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/teacherhomework/component/classitem.vue